<template>
  <ModalContainer :show="show" @close="onCancel">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <template slot="header">
      <h4 class="mb-0">{{ $t("add-origin") }}</h4>
    </template>

    <template slot="body">
      <form class="p-2" @submit.prevent="addorigin">
        <div style="display: flex; justify-content: space-between; gap: 1rem">
          <div style="width: 100%">
            <div class="form-group">
              <label for="name"> {{ $t("name") }}</label>
              <input
                type="text"
                name="name"
                v-model="name"
                class="form-control"
                required
                id="name"
                :placeholder="$t('enter-name')"
                style="text-transform: capitalize"
                @keypress="isLetter($event)"
              />
            </div>

            <div class="form-group">
              <label for="plateNumber"> {{ $t("region") }}</label>
              <input
                v-model="region"
                type="text"
                name="region"
                class="form-control"
                required
                id="region"
                :placeholder="$t('enter-region')"
              />
            </div>
          </div>

          <div style="width: 100%">
            <div class="form-group">
              <label for="address"> {{ $t("address") }}</label>
              <input
                type="text"
                name="address"
                class="form-control"
                required
                id="autocomplete"
                :placeholder="$t('enter-address')"
                ref="autocompleteInput"
                @input="onInputChange"
                v-model="address"
              />
            </div>

            <div class="form-group">
              <label for="country"> {{ $t("country") }} </label>
              <CountrySelect
                class="form-control"
                required
                id="country"
                v-model="country"
                :country="country"
                :countryLabel="'Select a Country'"
                :defaultOption="'Select a country'"
                :countryName="true"
              />
            </div>
          </div>
        </div>

        <div type="submit" class="btn-add">
          <button
            :disabled="!isValidLocation"
            :class="{
              'invalid-button': !isValidLocation,
              'valid-button': isValidLocation,
            }"
          >
            {{ $t("add") }}
          </button>
        </div>
      </form>
    </template>
  </ModalContainer>
</template>

<script>
import ModalContainer from "../../components/ModalContainer";
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { CountrySelect } from "vue-country-region-select";

export default {
  name: "AddOrigin",
  components: {
    ModalContainer,
    Loading,
    CountrySelect,
  },
  props: {
    show: Boolean,
    onCancel: Function,
    isAddShipment: {
      type: Boolean,
      default: false,
    },
    newShipmentOrigin: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,

      name: "",
      region: "",
      lat: null,
      lng: null,
      mssg: "",
      Errormssg: "",
      country: "",

      address: "",
      previousAddress: "",
      isClearing: false,
      isValidLocation: false,
    };
  },
  computed: {
    ...mapGetters(["origin"]),
  },
  methods: {
    ...mapActions(["addOrigin", "getOrigin"]),
    validateLocation() {
      this.isValidLocation =
        this.lat !== null &&
        this.lng !== null &&
        this.lat >= -90 &&
        this.lat <= 90 &&
        this.lng >= -180 &&
        this.lng <= 180;
    },

    onInputChange() {
      this.isClearing = this.address.length < this.previousAddress.length;

      this.previousAddress = this.address;

      if (this.isClearing || !this.address) {
        this.lat = null;
        this.lng = null;
      }

      this.validateLocation();
    },

    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
      else e.preventDefault();
    },
    initializeAutocomplete() {
      const { google } = window;
      this.geocoder = new google.maps.Geocoder();
      const input = document.getElementById("autocomplete");
      const autocomplete = new google.maps.places.Autocomplete(input);

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();

        if (place && place.formatted_address) {
          // The address was found in the autocomplete list
          this.address = place.formatted_address;

          // Get latitude and longitude from the place object
          const latLng = place.geometry?.location;

          if (latLng) {
            this.lat = latLng.lat();
            this.lng = latLng.lng();
            console.log("Latitude:", this.lat);
            console.log("Longitude:", this.lng);
          }
        } else {
          // The address was not in the autocomplete list, use geocoding
          const inputAddress = document.getElementById("autocomplete").value;
          console.log(
            "Address not found in autocomplete, geocoding:",
            inputAddress
          );

          // Use the Geocoder to get latitude and longitude for the entered address
          this.geocoder.geocode(
            { address: inputAddress },
            (results, status) => {
              if (
                status === google.maps.GeocoderStatus.OK &&
                results.length > 0
              ) {
                const result = results[0];

                const latLng = result.geometry.location;
                this.lat = latLng.lat();
                this.lng = latLng.lng();

                console.log("Geocoded Latitude:", this.lat);
                console.log("Geocoded Longitude:", this.lng);
              } else {
                console.error("Geocoding failed:", status);
              }
            }
          );
        }
        this.validateLocation();
      });
    },

    addorigin() {
      this.isLoading = true;
      const newOrigin = {
        name: this.name,
        address: {
          name: document.getElementById("autocomplete").value,
          lng: this.lng,
          lat: this.lat,
        },
        region: this.region,
        country: this.country,
      };
      if (this.isAddShipment) return this.$emit("newOrigin", newOrigin);
      this.addOrigin(newOrigin)
        .then((res) => {
          this.getOrigin();
          this.isLoading = false;
          this.onCancel();
          this.$emit("showSuccessPopup", {
            msg: this.$t("add_origin_mssg"),
            heading: this.$t("add_origin_heading"),
          });
        })
        .catch((error) => {
          console.log("newOrigin", newOrigin);

          console.error("Error adding origin:", error);
          this.isLoading = false;
          this.Errormssg = "Error adding origin. Please try again.";
        });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeAutocomplete();
    });
  },
  watch: {
    newShipmentOrigin: {
      handler(newValues) {
        if (newValues.address && this.isAddShipment) {
          this.$nextTick(() => {
            const autocompleteInput = this.$refs.autocompleteInput;
            if (autocompleteInput) {
              this.name = newValues.name || "";
              this.address = newValues.address.name || "";
              this.region = newValues.region || "";
              this.country = newValues.country || "";
              this.lat = newValues.address.lat || 0;
              this.lng = newValues.address.lng || 0;
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
label,
.form-control::placeholder {
  font-weight: 400;
  color: rgba(94, 106, 121, 1);
}

label {
  list-style: 15.6px;
  font-size: 12px;
}

.form-control::placeholder {
  font-size: 14px;
  line-height: 19.69px;
}

.btn-add {
  padding: 0;
  border-radius: 0;
  width: 100%;
  display: flex;
  justify-content: right;
}

.btn-add > button {
  border: none;
  border-radius: 16px;
  color: rgba(247, 248, 249, 1);
  width: 84px;
  height: 44px;
  padding: 12px, 30px, 12px, 30px;
  font-size: 14px;
  font-weight: 600;
}

.valid-button {
  background-color: rgba(33, 62, 122, 1);
  cursor: pointer;
}

.invalid-button {
  background-color: rgba(33, 62, 122, 0.8);
}
</style>
